/** Prefijo en `tenantUser.roles` para roles definidos por tenant (Mongo ObjectId hex). */
export const CUSTOM_ROLE_PREFIX = 'customRole:';

export function isCustomRoleToken(role: string): boolean {
  return typeof role === 'string' && role.startsWith(CUSTOM_ROLE_PREFIX);
}
